module.exports = __webpack_public_path__ + "img/InstagramIcon.a6f2fc0.svg";